/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import Loading from 'app/components/common/Loading.jsx';
import { Breakpoint } from 'react-socks';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import PricingModule from 'app/mixins/PricingModule.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import { setLauncherVisible } from 'app/utility/Intercom.js';

class UpgradeModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: '',
            add_on_social: 0,
            addOnError: ''
        };

        this.getGAPromoObject = this.getGAPromoObject.bind(this);
        this.closeUpgradeModal = this.closeUpgradeModal.bind(this);
        this.startUpgrade = this.startUpgrade.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getIndex = this.getIndex.bind(this);
        this.setVersion = this.setVersion.bind(this);

    }

    getGAPromoObject() {

        let constants = this.props.app.config.constants,
            index = this.getIndex(),
            promo = {},
            type = (this.props.isFreeOrTrialUser()) ? 'new' : 'upgrade',
            version = this.state.version;

        switch (index) {
            case 'outputs':
                promo.id = 'social_max';
                promo.name = 'Social Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'inputs':
                promo.id = 'feed_max';
                promo.name = 'Feed Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'twitterInput':
                promo.id = 'feed_twitter';
                promo.name = 'Feed Twitter';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pinterestOutput':
                promo.id = 'social_pinterest';
                promo.name = 'Social Pinterest';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'queue':
                promo.id = 'queue_max';
                promo.name = 'Queue Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'users':
            case 'users-plan':
                promo.id = 'team';
                promo.name = 'Team';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'curation':
                promo.id = 'curate';
                promo.name = 'Curate';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pullFreq':
                promo.id = 'feed_pull_freq';
                promo.name = 'Feed Pull Freq';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'unique':
                promo.id = 'social_second';
                promo.name = 'Social Second';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'feedOutput':
                promo.id = 'social_output_feed';
                promo.name = 'Social Output Feed';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'replay':
                promo.id = 'feed_echo';
                promo.name = 'Feed Echo';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'category':
                promo.id = 'category';
                promo.name = 'Category';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'everqueue':
                promo.id = 'everqueue';
                promo.name = 'EverQueue';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'contentImport':
                promo.id = 'contentImport';
                promo.name = "Content Import";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'importConnections':
                promo.id = 'importConnections';
                promo.name = "Import Connections";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'staticHashtags':
                promo.id = 'staticHashtags';
                promo.name = "Static Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'hashtagPool':
                promo.id = 'hashtagPool';
                promo.name = "Hashtag Pool";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'autoHashtags':
                promo.id = 'autoTopicTags';
                promo.name = "Auto Detected Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'smartHashtags':
                promo.id = 'aiHashtags';
                promo.name = "AI Generated Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pushUpdates':
                promo.id = 'pushUpdates';
                promo.name = "PuSH Updates";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'clients':
                promo.id = 'clients';
                promo.name = "Add Client";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'clientSeatLimit':
                promo.id = 'clientSeatLimit';
                promo.name = "Add More Clients";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'apikey':
                promo.id = 'apikey';
                promo.name = "API Key";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'linkpage':
                promo.id = 'linkpage';
                promo.name = "Link Page";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'postAnalyzer':
                promo.id = 'postAnalyzer';
                promo.name = "Post Analyzer";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'moveSocial':
                promo.id = 'moveSocial';
                promo.name = "Move Social";
                promo.creative = [promo.id, type, version].join(".");
                break;

            default:
                break;

        }

        promo.position = this.props.trigger;

        return promo;

    }

    componentDidMount() {

        setLauncherVisible(false);

        this.setVersion();
        this.props.getPlans();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps && prevProps.app.loading.SUB_FETCH_PLANS === true && this.props.app.loading.SUB_FETCH_PLANS === false) {
            if (!_.isEmpty(this.props.user.plan) && this.props.user.plan.addOns.add_on_social !== undefined) {
                this.setState({
                    add_on_social: this.props.user.plan.addOns.add_on_social.qty
                });
            }
        }
    
    }

    setVersion() {
        if (this.props.user.detail.id !== undefined && this.state.version === "") {
            let version = "nov2025";
            // if (parseInt(this.props.user.id, 10) > 0) {
            //     version = (parseInt(this.props.user.id, 10) % 2) ? "GREEN" : "GREEN";
            // }

            this.setState({
                version: version
            }, () => {
                let promo = this.getGAPromoObject();

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Upgrade Prompt View',
                        event_data: {
                            promotion_id: promo.id,
                            promotion_name: promo.name
                        }
                    })
                }

                // if (dataLayer) {
                //     dataLayer.push({
                //         'event': 'promotionView',
                //         'ecommerce': {
                //             'promoView': {
                //                 'promotions': [
                //                     {
                //                         'id': promo.id,
                //                         'name': promo.name,
                //                         'creative': promo.creative,
                //                         'position': promo.position
                //                     }
                //                 ]
                //             }
                //         },
                //         //GA 4 params
                //         'promotion_id': promo.id,
                //         'promotion_name': promo.name,
                //         'creative_name': promo.creative,
                //         'creative_slot': promo.position,
                //         items: [
                //             {
                //                 item_id: 'dlvrit_1',
                //                 item_name: 'dlvr.it premium plan',
                //                 price: 1.00,
                //                 quantity: 1
                //             }
                //         ]
                //     });
                // }

                if (gtag) {
                    gtag('event', 'view_promotion', {
                        'promotion_id': promo.id,
                        'promotion_name': promo.name,
                        'creative_name': promo.creative,
                        'creative_slot': promo.position,
                        items: [
                            {
                                item_id: 'dlvrit_1',
                                item_name: 'dlvr.it premium plan',
                                price: 1.00,
                                quantity: 1
                            }
                        ]
                    });
                }
            });

        }

    }


    closeUpgradeModal() {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Upgrade Modal Dismissed',
                event_data: {
                    modal: this.getIndex()
                }
            });
        }

        this.props.modalHandler.apply(this, []);

    }

    startUpgrade(e) {
        let constants = this.props.app.config.constants,
            link = (e.currentTarget.dataset.link !== undefined) ? e.currentTarget.dataset.link : false,
            promo = this.getGAPromoObject(),
            redirector = () => {
                if (link) {
                    this.props.router.navigate(link);
                } else if (this.props.isFreeOrTrialUser(this.props.user.detail.pubLevel)) {
                    if (['category', 'everqueue', 'contentImport', 'importConnections', 'hashtagPool', 'postAnalyzer'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/new?plan=9');
                    } else if (['team', 'feed_max', 'social_max', 'social_output_feed', 'feed_pull_freq', 'feed_echo', 'staticHashtags', 'autoTopicTags', 'pushUpdates', 'clients', 'clientsSeatLimit', 'linkpage', 'apikey', 'aiHashtags'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/new?plan=6');
                    } else {
                        this.props.router.navigate('/account/subscription/new');
                    }

                } else {
                    if (['category', 'everqueue', 'contentImport', 'importConnections', 'hashtagPool', 'postAnalyzer'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/change?plan=9');
                    } else if (promo.id === 'team') {
                        this.props.router.navigate('/account/subscription/change?plan=8');
                    } else if (['feed_max', 'social_max'].indexOf(promo.id) !== -1) {
                        let addOnQty = 0;
                        if (!_.isEmpty(this.props.user.plan) && this.props.user.plan.addOns.add_on_social !== undefined) {
                            addOnQty = this.props.user.plan.addOns.add_on_social.qty;
                        }
                        if (addOnQty !== this.state.add_on_social) {
                            this.props.updateSocialAddOns(this.state.add_on_social);
                        } else if (this.props.isTrialUser()) {
                            this.props.router.navigate(`/account/subscription/new`);
                        } else {
                            let nextPlan = constants.PUB_LEVEL_6;
                            this.props.router.navigate(`/account/subscription/change?plan=${nextPlan}`);
                        }

                    } else {
                        this.props.router.navigate('/account/subscription/change?plan=6');
                    }
                }
            };

        e.preventDefault();
        e.stopPropagation();

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': promo.id,
        //                         'name': promo.name,
        //                         'creative': promo.creative,
        //                         'position': promo.position
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': promo.id,
        //         'promotion_name': promo.name,
        //         'creative_name': promo.creative,
        //         'creative_slot': promo.position,
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': promo.id,
                'promotion_name': promo.name,
                'creative_name': promo.creative,
                'creative_slot': promo.position,
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': promo.id,
                'promotion_name': promo.name,
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Select Promotion',
                event_data: {
                    promotion_id: promo.id,
                    promotion_name: promo.name
                }
            })
        }

        redirector();

    }

    getContent(index, plan) {
        const contentRepository = {
            'inputs': {
                pitch: 'The :currentPlan comes with :currentFeedCount feeds',
                detail: 'Upgrade to :nextPlan and easily share great content from up to :nextFeedCount feeds.',
                button: 'Upgrade to :nextPlan'
            },
            'inputs-plan': {
                pitch: 'Scale your distribution.',
                detail: 'You’ve reached your account limit. Add a pack of 50 content inputs and expand your reach.',
                button: 'Add More Inputs'
            },
            'outputs': {
                pitch: 'The :currentPlan includes :socials social media pages',
                detail: 'Upgrade to :nextPlan and connect all your social media pages.',
                button: 'Upgrade to :nextPlan'
            },
            'outputs-plan': {
                pitch: "Expand your capacity.",
                detail: '',
                subdetail: 'You’ve reached your account limit. Add a pack of 10 profiles and keep expanding your content distribution.',
                button: 'Add More Profiles'
            },
            'queue': {
                pitch: 'The :currentPlan includes :queueCount queued items per social.',
                detail: 'Upgrade to :nextPlan and easily queue up to :nextQueueCount items per social.',
                button: 'Upgrade to :nextPlan'
            },
            'twitterInput': {
                pitch: 'Twitter inputs are not part of the :currentPlan',
                detail: 'Upgrade to :nextPlan and easily share content from Twitter to all your socials.',
                button: 'Upgrade to :nextPlan'
            },
            'pinterestOutput': {
                pitch: 'Posting to Pinterest is not part of the :currentPlan',
                detail: 'Upgrade to :nextPlan and easily share beautiful images on Pinterest.',
                button: 'Upgrade to :nextPlan'
            },
            'users': {
                pitch: 'The :currentPlan does not include team members.',
                detail: 'Upgrade to Pro and share workload with two additional team members.',
                button: 'Upgrade to Pro'
            },
            'users-plan': {
                pitch: 'Scale your team.',
                detail: 'You’ve hit the 2-member Pro Plan limit. Get in touch to add more teammates.',
                button: 'Contact Us'
            },
            'curation': {
                pitch: 'Curation is not part of your Legacy plan.',
                detail: 'Get curation with a switch to any current dlvr.it plan.',
                button: 'Update plan'
            },
            'feedOutput': {
                pitch: 'Custom RSS Feeds are not part of the :currentPlan',
                detail: 'Upgrade to Pro and easily share more great content to a custom rss feed.',
                button: 'Upgrade to Pro'
            },
            'unique': {
                pitch: 'Your plan includes one page per social network.',
                detail: 'Upgrade to :nextPlan and connect multiple pages per social network.',
                button: 'Upgrade to :nextPlan'
            },
            'pullFreq': {
                pitch: 'The :currentPlan comes with 3 hour updates',
                detail: "Upgrade to Pro and we'll check your feed for new items every 5 minutes",
                button: 'Upgrade to Pro'
            },
            'replay': {
                pitch: 'Your plan does not include Echo',
                detail: "Go Pro and queue your posts for recycling days or weeks later for maximum traffic.",
                button: 'Upgrade to Pro'
            },
            'category': {
                pitch: 'Your plan does not include Category Manager',
                detail: "Upgrade to Plus and customize posting schedules for all your content types.",
                button: 'Upgrade to Plus'
            },
            'everqueue': {
                pitch: 'Put your growth on autopilot.',
                detail: "Stop letting your best content go to waste. Upgrade to Plus to automatically recycle your top posts and stay active 24/7.",
                button: 'Upgrade to Plus'
            },
            'contentImport': {
                pitch: 'Your plan does not include Bulk Scheduler',
                detail: "Upgrade to Plus and instantly schedule hundreds of posts from your favorite sources",
                button: 'Upgrade to Plus'
            },
            'importConnections': {
                pitch: 'Your plan does not include WordPress Scheduler',
                detail: "Upgrade to Plus to import and schedule posts from your WordPress blog.",
                button: 'Upgrade to Plus'
            },
            'staticHashtags': {
                pitch: 'Your plan does not include Static Hashtags',
                detail: "Upgrade to Pro and automatically include hashtags in every post.",
                button: 'Upgrade to Pro'
            },
            'hashtagPool': {
                pitch: 'Simplify your reach.',
                detail: "The Pro Plan does not include Hashtag Pools. Upgrade to Plus and rotate through your custom tags automatically.",
                button: 'Upgrade to Plus'
            },
            'autoHashtags': {
                pitch: 'Your plan does not include Auto Detected Hashtags',
                detail: "Upgrade to Pro and we'll automatically detect and add hashtags to every post.",
                button: 'Upgrade to Pro'
            },
            'smartHashtags': {
                pitch: 'Your plan does not include Smart Hashtags',
                detail: "Upgrade to Pro and our AI powered hashtag tool can generate relevant hashtags for every post.",
                button: 'Upgrade to Pro'
            },
            'pushUpdates': {
                pitch: 'The :currentPlan comes with 3 hour updates',
                detail: "Upgrade to Pro and we'll instantly post your PuSH enabled feed updates.",
                button: 'Upgrade to Pro'
            },
            'clients': {
                pitch: 'Onboard clients faster.',
                detail: "Let's talk and we can help you invite clients to safely connect their own profiles.",
                button: 'Contact Us'
            },
            'clientSeatLimit': {
                pitch: "You've reached your maximum number of clients",
                detail: "Contact us to add more.",
                button: 'Contact Us'
            },
            'linkpage': {
                pitch: 'The :currentPlan does not include Link Pages',
                detail: "Turn Instagram posts into a clickable Bio Link Page and drive traffic.",
                button: 'Upgrade to Pro'
            },
            'apikey': {
                pitch: 'The :currentPlan does not include API access',
                detail: "Get an API key and hook dlvr.it into your own custom workflow.",
                button: 'Upgrade to Pro'
            },
            'postAnalyzer': {
                pitch: 'The :currentPlan does not include the Post Analyzer',
                detail: "Get valuable insights and quickly repost your most popular content.",
                button: 'Upgrade to Plus'
            },
            'twitterOutput': {
                pitch: 'Boost your X presence.',
                detail: "The Launch Plan is limited to 10 posts on X. Upgrade to Pro and unlock 200+ tweets per profile.",
                button: 'Add more tweets'
            },
            'moveSocial': {
                pitch: 'Social Profile Already Linked',
                detail: "This social has been used in another dlvr.it account. To add it here, please upgrade your plan.",
                button: 'Upgrade to Pro'
            }
        };

        const planSpecificContent = {
            17: { // Free trial specific
                'inputs': {
                    pitch: "You’re a power user.",
                    detail: "You’ve hit the 100-input trial limit. Upgrade to Pro to add more.",
                    button: "Upgrade to Pro",
                    link: "/account/subscription/new?plan=6&addons=1"
                },
                'inputs-plan': {
                    pitch: "You’re a power user.",
                    detail: "You’ve hit the 100-input trial limit. Upgrade to Pro to add more.",
                    button: "Upgrade to Pro",
                    link: "/account/subscription/new?plan=6&addons=1"
                },
                'outputs': {
                    pitch: "You’re scaling fast.",
                    detail: "You’ve hit the 10 social profile trial limit. Upgrade to Pro to add more.",
                    button: "Upgrade to Pro",
                    link: "/account/subscription/new?plan=6&addons=1"
                },
                'outputs-plan': {
                    pitch: "You’re scaling fast.",
                    detail: "You’ve hit the 10 social profile trial limit. Upgrade to Pro to add more.",
                    button: "Upgrade to Pro",
                    link: "/account/subscription/new?plan=6&addons=1"
                },
                'users-plan': {
                    pitch: 'You’re building a team.',
                    detail: 'You’ve hit the 2-member trial limit. Upgrade to Agency to add more teammates.',
                    button: 'Upgrade to Agency'
                },
                'twitterOutput': {
                    pitch: 'X (Twitter) limit reached.',
                    detail: "Due to X platform costs, trial accounts are limited to 200 posts. Upgrade to Pro to unlock higher volume.",
                    button: 'Upgrade to Pro'
                },
                'postAnalyzer': {
                    pitch: 'Optimize your strategy.',
                    detail: "Unlock full analytics to see exactly what drives your growth. Upgrade to Plus to refine your posting strategy.",
                    button: 'Upgrade to Plus'
                },
                'postLimit': {
                    pitch: "You’re ahead of schedule.",
                    detail: "You’ve hit the 250-post queue limit per profile. Upgrade to Pro to add more and keep your momentum.",
                    button: 'Upgrade to Pro'
                },
                'everqueue': {
                    pitch: 'Put your growth on autopilot.',
                    detail: "Stop letting your best content go to waste. Upgrade to Plus to automatically recycle your top posts and stay active 24/7.",
                    button: 'Upgrade to Plus'
                },
                'hashtagPool': {
                    pitch: 'Simplify your reach.',
                    detail: "The trial does not include Hashtag Pools. Upgrade to Plus and rotate through your custom tags automatically.",
                    button: 'Upgrade to Plus'
                },
                'clients': {
                    pitch: 'Onboard clients faster.',
                    detail: "The trial does not include Client Seats. Upgrade to Pro and invite clients to safely connect their own profiles.",
                    button: 'Contact Us'
                }
            },
            1: { // Free plan specific
                'unique': {
                    pitch: 'Manage multiple identities.',
                    detail: 'The Launch Plan 1 profile per network. Upgrade to Pro and connect 10+ profiles across any network.',
                    button: 'Upgrade to Pro'
                },
                'outputs': {
                    pitch: "Manage more profiles.",
                    detail: "The Launch Plan is limited to 3 profiles. Upgrade to Pro and scale your reach across 10+ profiles.",
                    button: "Upgrade to Pro",
                },
                'outputs-plan': {
                    pitch: "Manage more profiles.",
                    detail: "The Launch Plan is limited to 3 profiles. Upgrade to Pro and scale your reach across 10+ profiles.",
                    button: "Upgrade to Pro",
                },
                'inputs': {
                    pitch: "Automate more sources.",
                    detail: "The Launch Plan is limited to 1 content input. Upgrade to Pro and automate 100+ sources.",
                    button: "Upgrade to Pro",
                },
                'inputs-plan': {
                    pitch: "Automate more sources.",
                    detail: "The Launch Plan is limited to 1 content input. Upgrade to Pro and automate 100+ sources.",
                    button: "Upgrade to Pro",
                },
                'users': {
                    pitch: 'Scale your team.',
                    detail: 'The Launch Plan is for individual creators. Upgrade to Pro and add team members to collaborate on every post.',
                    button: 'Upgrade to Pro'
                },
                'postLimit': {
                    pitch: 'Keep the momentum going.',
                    detail: "The Launch Plan is limited to 10 queued posts. Upgrade to Pro and queue 250+ posts for each profile.",
                    button: 'Upgrade to Pro'
                },
                'twitterOutput': {
                    pitch: 'Boost your X presence.',
                    detail: "The Launch Plan is limited to 10 posts on X. Upgrade to Pro and unlock 200+ tweets per profile.",
                    button: 'Upgrade to Pro'
                },
                'postAnalyzer': {
                    pitch: "See what's working.",
                    detail: "The Launch Plan is limited to basic stats. Upgrade to Plus and unlock deep analytics to refine your growth strategy.",
                    button: 'Upgrade to Plus'
                },
                'replay': {
                    pitch: 'Multiply your reach.',
                    detail: "The Launch Plan does not include Echoes. Upgrade to Pro and repeat your best posts automatically.",
                    button: 'Upgrade to Pro'
                },
                'pushUpdates': {
                    pitch: 'Broadcast instantly.',
                    detail: "The Launch Plan checks for new items every 6 hours. Upgrade to Pro for instant publishing.",
                    button: 'Upgrade to Pro'
                },
                'category': {
                    pitch: 'Organize your content strategy.',
                    detail: "The Launch Plan does not include categories. Upgrade to Plus and unlock content categories to manage custom schedules for every topic.",
                    button: 'Upgrade to Plus'
                },
                'contentImport': {
                    pitch: 'Import content in bulk.',
                    detail: "The Launch Plan does not support bulk scheduling. Upgrade to Plus and upload hundreds of posts at once with CSV bulk imports.",
                    button: 'Upgrade to Plus'
                },
                'autoHashtags': {
                    pitch: 'Get more views.',
                    detail: "The Launch Plan does not include Auto Hashtags. Upgrade to Pro and generate high-performing tags automatically.",
                    button: 'Upgrade to Pro'
                },
                'smartHashtags': {
                    pitch: 'Get more views.',
                    detail: "The Launch Plan does not include AI hashtags. Upgrade to Pro and generate high-performing tags automatically.",
                    button: 'Upgrade to Pro'
                },
                'linkpage': {
                    pitch: 'Unlock Instagram links',
                    detail: "The Launch Plan does not include Link Pages. Upgrade to Pro and turn every Instagram post into a direct link to your website.",
                    button: 'Upgrade to Pro'
                },
                'apikey': {
                    pitch: 'Build your own integrations.',
                    detail: "The Launch Plan does not include API access. Upgrade to Pro and generate a private API key to connect your custom tools.",
                    button: 'Upgrade to Pro'
                },
                'everqueue': {
                    pitch: 'Auto recycle your best content.',
                    detail: "The Launch Plan does not include post recycling. Upgrade to Plus and keep your best posts on repeat.",
                    button: 'Upgrade to Plus'
                },
                'clients': {
                    pitch: 'Onboard clients faster.',
                    detail: "The Launch Plan does not include Client Seats. Upgrade to Pro and invite clients to safely connect their own profiles.",
                    button: 'Contact Us'
                }
            }
        }

        let content = {};
        if (contentRepository[plan] !== undefined && contentRepository[plan][index] !== undefined) {
            content = Object.assign({}, contentRepository[plan][index]);
        } else if (contentRepository[index] !== undefined) {
            content = Object.assign({}, contentRepository[index]);
        }

        return content;

    }

    getIndex() {
        let index = '',
            constants = this.props.app.config.constants;

        if (this.props.context === 'socials' || this.props.errorCode == constants.P_SOCIAL_LIMIT) {
            index = 'outputs';
        } else if (this.props.context == 'inputs' || this.props.errorCode == constants.P_INPUT_LIMIT) {
            index = 'inputs';
        } else if (this.props.context == 'twitterInput' || this.props.errorCode == constants.P_INPUT_RESTRICTION) {
            index = 'twitterInput';
        } else if (this.props.context == 'pinterest' || this.props.errorCode == constants.P_SOCIAL_RESTRICTION) {
            index = 'pinterestOutput';
        } else if (this.props.context == 'queue' || this.props.errorCode == constants.P_QUEUE_LIMIT) {
            index = 'queue';
        } else if (this.props.context == 'users' || this.props.errorCode == constants.P_SUB_RESTRICTION) {
            index = 'users';
        } else if (this.props.context == 'usersLimit' || this.props.errorCode == constants.P_SUB_LIMIT) {
            index = 'users-plan';
        } else if (this.props.context == 'clients' || this.props.errorCode == constants.P_CLIENT_ACCTS) {
            index = 'clients';
        } else if (this.props.context == 'clientSeatLimit' || this.props.errorCode == constants.P_CLIENT_ACCT_LIMIT) {
            index = 'clientSeatLimit';
        } else if (this.props.context == 'curation' || this.props.errorCode == constants.P_CURATION) {
            index = 'curation';
        } else if (this.props.context == 'pullFreq' || this.props.errorCode == constants.P_PULLFREQ_RESTRICTION) {
            index = 'pullFreq';
        } else if (this.props.context == 'postLimit' || this.props.errorCode == constants.P_POSTLIMIT_RESTRICTION) {
            index = 'postLimit';
        } else if (this.props.context == 'unique' || this.props.errorCode == constants.P_SOCIAL_MULTI) {
            index = 'unique';
        } else if (this.props.context == 'feedOutput' || this.props.errorCode == constants.P_SOCIAL_RESTRICTION) {
            index = 'feedOutput';
        } else if (this.props.context == 'replay' || this.props.errorCode == constants.P_REPEAT_POST) {
            index = 'replay';
        } else if (this.props.context == 'category' || this.props.errorCode == constants.P_CATEGORIES) {
            index = 'category';
        } else if (this.props.context == 'everqueue' || this.props.errorCode == constants.P_EVERQ) {
            index = 'everqueue';
        } else if (this.props.context == 'contentImport' || this.props.errorCode == constants.P_BULK_IMPORT) {
            index = 'contentImport';
        } else if (this.props.context == 'importConnections' || this.props.errorCode == constants.P_GENERIC_ACCTS) {
            index = 'importConnections';
        } else if (this.props.context == 'staticHashtags' || this.props.errorCode == constants.P_HASH_STATIC) {
            index = 'staticHashtags';
        } else if (this.props.context == 'hashtagPool' || this.props.errorCode == constants.P_HASH_POOL) {
            index = 'hashtagPool';
        } else if (this.props.context == 'autoHashtags' || this.props.errorCode == constants.P_AUTO_HASH) {
            index = 'autoHashtags';
        } else if (this.props.context == 'pushUpdates' /*|| this.props.errorCode == constants.P_AUTO_HASH*/) {
            index = 'pushUpdates';
        }  else if (this.props.context === 'linkpage') {
            index = "linkpage";
        } else if (this.props.errorCode === constants.P_APIKEYS) {
            index = "apikey";
        } else if (this.props.context == 'smartHashtags' || this.props.errorCode == constants.P_AI_HASH) {
            index = "smartHashtags";
        } else if (this.props.context === 'postAnalyzer') {
            index = 'postAnalyzer';
        } else if (this.props.context === 'twitterOutput') {
            index = 'twitterOutput';
        } else if (this.props.context === 'moveSocial') {
            index = 'moveSocial';
        }

        return index;

    }

    render() {
        let imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            content = null,
            pitch = "Mmmmm. Smells like an upgrade.",
            constants = this.props.app.config.constants,
            index = '',
            copy = null,
            detail = '',
            subFooterClass = 'pro-features',
            mainClass = "upgrade",
            modalContent = null,
            cta = null,
            isAgent = this.props.user.detail.isAgent;

        const generateLabel = (plan, quantity, label) => {
            let constants = this.props.app.config.constants,
                planQuantity = 0,
                baseQuantity = 0,
                mixedDisplay = false;

            if (!label) {
                mixedDisplay = true;
            }

            if (!_.isEmpty(this.props.plans.details) && plan) {
                baseQuantity = parseInt(this.props.plans.details[plan].limits.hardLimitOutputs);
                if (this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
                    planQuantity = this.props.plans.details[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials;
                }
                if (mixedDisplay) {
                    return (
                        <div>
                            <span className="number-display">{baseQuantity + (quantity * planQuantity)}</span> socials
                        </div>
                    );
                } else {
                    return baseQuantity + (quantity * planQuantity) + label;
                }
            }

            return '';
        }

        const updateAddOnQuantity = (plan, quantity) => {
            let nextQty = quantity,
                newLimits = null,
                currentInputs = parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable,
                currentOutputs = parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable,
                constants = this.props.app.config.constants;

            if ((nextQty < this.state.add_on_social)) {
                newLimits = this.props.calculateAddOns([{
                    addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                    quantity: nextQty
                }]);
                if ((newLimits.inputs < currentInputs) || (newLimits.outputs < currentOutputs)) {
                    this.setState({
                        addOnError: "Your usage would exceed the new limits with fewer add-ons. Turn off or remove feeds and socials to fit the limits."
                    });
                    return;
                }
            }

            if (nextQty >= 0) {
                this.setState({
                    addOnError: '',
                    add_on_social: nextQty,
                });
            }

        };

        const searchAndReplace = (copy) => {
            let keys = Object.keys(copy),
                that = this;

            keys.map((key) => {
                let constants = that.props.app.config.constants;

                if (copy[key].match(":socials")) {
                    copy[key] = copy[key].replace(":socials", that.props.user.perms.perms.hardLimitOutputs);
                }
                if (copy[key].match(":feeds")) {
                    copy[key] = copy[key].replace(":feeds", that.props.user.perms.perms.hardLimitInputs);
                }
                if (copy[key].match(":price") && !isAgent) {
                    if (parseInt(that.props.user.plan.planTerm, 10) === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        copy[key] = copy[key].replace(":price", "$" + constants.SUBSCRIPTION_ADDON_PRICES[that.props.user.detail.pubLevel][constants.SUBSCRIPTION_TERM_MONTHLY][constants.SUBSCRIPTION_ADDON_SOCIALS].toFixed(2) + " / month");
                    } else {
                        copy[key] = copy[key].replace(":price", "$" + constants.SUBSCRIPTION_ADDON_PRICES[that.props.user.detail.pubLevel][constants.SUBSCRIPTION_TERM_ANNUAL][constants.SUBSCRIPTION_ADDON_SOCIALS].toFixed(2) + " / year");
                    }
                } else if (copy[key].match(":price") && isAgent) {
                    // go generic on 'em
                    copy[key] = copy[key].replace(":price", "cost");
                }

                let currentPlan = that.props.plans.details[that.props.user.detail.pubLevel],
                    nextPlan = that.props.plans.details[constants.PUB_LEVEL_6];
                if (that.props.isTrialUser()) {
                    if (copy[key].match(":currentPlan")) {
                        if (index === "outputs") {
                            copy[key] = "Free trial includes 10 social accounts";
                        } else if (index === "inputs") {
                            copy[key] = "Free trial includes 50 inputs";
                        } else {
                            copy[key] = copy[key].replace(":currentPlan", "free trial");
                        }
                    }
                    if (key === "detail" && (index === "outputs" || index === "inputs")) {
                        copy[key] = "Upgrade to Pro and keep growing";
                    }
                    // if (key === "detail" && index === "inputs") {
                    //     copy[key] = `Upgrade to Pro and easily share great content from up to ${that.props.plans.details[constants.PUB_LEVEL_6].limits.hardLimitInputs} feeds.`
                    // }
                    if (key == "button" && (index === "inputs" || index === "outputs")) {
                        copy[key] = 'Get Pro';
                    }
                    if (copy[key].match(":nextPlan")) {
                        copy[key] = copy[key].replace(":nextPlan", `${nextPlan.label}`);
                    }
                } else {
                    if (copy[key].match(":currentPlan")) {
                        copy[key] = copy[key].replace(":currentPlan", `${currentPlan.label} plan`);
                    }
                    if (copy[key].match(":nextPlan")) {
                        copy[key] = copy[key].replace(":nextPlan", `${nextPlan.label}`);
                    }
                }

                if (copy[key].match(":currentFeedCount")) {
                    copy[key] = copy[key].replace(":currentFeedCount", currentPlan.limits.hardLimitInputs);
                }
                if (copy[key].match(":nextFeedCount")) {
                    copy[key] = copy[key].replace(":nextFeedCount", nextPlan.limits.hardLimitInputs);
                }
                if (copy[key].match(":queueCount")) {
                    copy[key] = copy[key].replace(":queueCount", that.props.user.perms.resources.qLimit);
                }
                if (copy[key].match(":nextQueueCount")) {
                    copy[key] = copy[key].replace(":nextQueueCount", nextPlan.limits.qDirectMax);
                }
            });
        }

        index = this.getIndex();

        if (!this.props.isFreeOrTrialUser() &&
            !this.props.isStarterUser() &&
            !this.props.isBasicUser() &&
             (index === 'inputs' || index === 'outputs')) {
            index += "-plan";
        }

        // tag on the current version to the style list
        mainClass += " nov2025";

        if (this.props.user.detail.trialEligible) {
            subFooterClass += ' large';
        }

        if (Object.keys(this.props.plans.details).length) {
            copy = this.getContent(index, this.props.user.detail.pubLevel);

            if (Object.keys(copy).length === 0) {
                // if there's no copy, it's possible this is being called in error, bail until the situation
                // is better resolved by upstream code (which will send an explicit context or error code that matches)
                return;
            }

            searchAndReplace(copy);

            if (index == 'inputs-plan' || index == 'outputs-plan') {
                if (this.props.isPlusUser()) {
                    // versions
                    copy.detail = copy.detail.replace("10 socials", "5 socials");
                    copy.detail = copy.detail.replace("50 feeds", "25 feeds");

                    copy.detail = copy.detail.replace("10 profiles", "5 profiles");
                    copy.detail = copy.detail.replace("50 content inputs", "25 content inputs");
                }
            }

            let versionClass =  'nov2025';
            if (isAgent) {
                cta = (
                    <button className={`continue-upgrade ${versionClass}`} onClick={this.closeUpgradeModal}>
                        Contact the account owner to upgrade
                    </button>
                );
            } else if (this.props.showCTA) {
                if (copy.link !== undefined) {
                    cta = (
                        <button className={`continue-upgrade ${versionClass}`} onClick={this.startUpgrade} data-link={copy.link}>
                            {copy.button}
                        </button>
                    );
                } else {
                    cta = (
                        <button className={`continue-upgrade ${versionClass}`} onClick={this.startUpgrade}>
                            {copy.button}
                        </button>
                    );
                }

            } else if (this.props.showCTA === false && (['clients', 'clientSeatLimit', 'users-plan'].indexOf(index) !== -1)) {
                cta = (
                    <button className={`continue-upgrade ${versionClass}`} onClick={() => {
                            window.location.href = 'mailto:support@dlvr.it';
                            this.props.closeAllModals();
                        }}>
                        Contact Us
                    </button>
                );
            }

            let addOnChooser = null;
            if (["socials", "outputs", "inputs", "outputs-plan", "inputs-plan"].indexOf(index) !== -1 && (!this.props.isFreeOrTrialUser() && !this.props.isBasicUser() && !this.props.isStarterUser())) {
                let addOnQty = 0;
                if (!_.isEmpty(this.props.user.plan) && this.props.user.plan.addOns.add_on_social !== undefined) {
                    addOnQty = this.props.user.plan.addOns.add_on_social.qty;
                }
                if (addOnQty !== this.state.add_on_social) {
                    cta = (
                        <button className={`continue-upgrade ${versionClass}`} onClick={this.startUpgrade}>
                            {copy.button}
                        </button>
                    );
                } else {
                    cta = (
                        <button className={`continue-upgrade inactive ${versionClass}`} onClick={() => null}>
                            {copy.button}
                        </button>
                    );
                }
                addOnChooser = (
                    <div className="add-on-upgrade">
                        <div className="add-on-title">Plan Outputs:</div>
                        <AddOnWidget
                            className="add-on-widget new-subscription"
                            plan={this.props.user.plan.planLevel}
                            term={this.props.user.plan.planTerm}
                            addOns={addOnQty}
                            onQuantityChange={updateAddOnQuantity}
                            labelMaker={generateLabel} />
                    </div>
                );
            }

            let upgradeImage = `${imageUrl}/upgrade-modal/star-stars-icon.svg`;
            if (index === 'moveSocial') {
                upgradeImage = `${imageUrl}/upgrade-modal/connect.svg`;
            }

            content = (
                <div>
                    <div className={`dlvr-upgrade-detail ${versionClass}`}>
                        <div className="upgrade-image">
                            <img src={upgradeImage}/>
                        </div>
                        <div className="upgrade-copy">
                            <div className="copy-pitch">
                                {copy.pitch}
                            </div>
                            {copy.detail ? (
                                <div className="copy-detail">
                                    {copy.detail}
                                </div>
                            ) : null}
                        </div>
                        {this.state.addOnError !== '' ? (
                            <div className="add-on-error">
                                {this.state.addOnError}
                            </div>
                        ) : null}
                        {addOnChooser}
                        {cta}
                        {copy?.subdetail ? (
                            <div className="copy-subdetail">
                                {copy.subdetail}
                            </div>
                        ) : null}
                    </div>
                </div>
            );

        } else {
            content = (
                <Loading/>
            );
        }

        modalContent = (
            <div>
                <Breakpoint desktop only>
                    <Modal
                        headerContent={null}
                        mainClass={mainClass}
                        content={content}
                        close={this.closeUpgradeModal}
                        hasBackground={this.props.hasBackground}
                        transparentHeader={true}
                        wrapperClass="upgrade-modal"/>
                </Breakpoint>
                <Breakpoint mobile only>
                    <Modal
                        headerContent={null}
                        mainClass={mainClass}
                        content={content}
                        close={this.closeUpgradeModal}
                        transparentHeader={true}
                        hasBackground={this.props.hasBackground}
                        wrapperClass="mobile-upgrade"/>
                </Breakpoint>
            </div>
        );

        return modalContent;
    }

};

UpgradeModal.displayName = "UpgradeModal";

UpgradeModal.propTypes = {
    showCTA: PropTypes.bool
};

UpgradeModal.defaultProps = {
    showCTA: true
};

const enhance = compose(
    PricingModule,
    SubscriptionModule
);

export default enhance(UpgradeModal);
